/**
 * Enrobage minimal d'IndexedDB (sans dépendance) pour le mode hors-ligne.
 * Magasins : `kv` (instantané de l'inventaire), `queue` (mouvements en attente,
 * idempotents par client_id), `scans` (file du scanner en rafale asynchrone).
 */
const DB_NAME = 'vd-offline';
const VERSION = 2;
let _db;

function open() {
  if (_db) return Promise.resolve(_db);
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const d = req.result;
      if (!d.objectStoreNames.contains('kv')) d.createObjectStore('kv');
      if (!d.objectStoreNames.contains('queue')) d.createObjectStore('queue', { keyPath: 'client_id' });
      if (!d.objectStoreNames.contains('scans')) d.createObjectStore('scans', { keyPath: 'id' });
    };
    req.onsuccess = () => { _db = req.result; resolve(_db); };
    req.onerror = () => reject(req.error);
  });
}

function run(store, mode, fn) {
  return open().then((d) => new Promise((resolve, reject) => {
    const tx = d.transaction(store, mode);
    const req = fn(tx.objectStore(store));
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  }));
}

export const kvGet = (key) => run('kv', 'readonly', (s) => s.get(key));
export const kvSet = (key, val) => run('kv', 'readwrite', (s) => s.put(val, key));
export const queueAdd = (op) => run('queue', 'readwrite', (s) => s.put(op));
export const queueAll = () => run('queue', 'readonly', (s) => s.getAll()).then((r) => r || []);
export const queueRemove = (clientId) => run('queue', 'readwrite', (s) => s.delete(clientId));

// File du scanner en rafale (persiste photos + statut pour survivre à un rechargement).
export const scanPut = (item) => run('scans', 'readwrite', (s) => s.put(item));
export const scanAll = () => run('scans', 'readonly', (s) => s.getAll()).then((r) => r || []);
export const scanRemove = (id) => run('scans', 'readwrite', (s) => s.delete(id));
export const scanClear = () => run('scans', 'readwrite', (s) => s.clear());
